var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20.4,
    fill: "url(#phone_svg__a)",
    opacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M19.85 13.116c.734.892 1.048 1.387 1.676 2.279.735.99.525 2.377-.523 3.072l-1.782 1.189c-2.2 1.485 5.45 11.79 7.756 10.304l1.782-1.19c1.048-.693 2.515-.495 3.249.495.628.893 1.048 1.387 1.676 2.28.734.99.734 2.774-.314 3.468-8.908 5.944-26.096-16.646-16.979-22.69 1.049-.693 2.725-.198 3.46.793Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_svg__a",
    x1: 44.898,
    x2: 3.578,
    y1: 23.369,
    y2: 23.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgPhone;